module.exports = __webpack_public_path__ + "img/n3.40c60064.png";